import React from 'react';
import featureEnabled from 'shared/helper/feature';
var linkInLanguage = function linkInLanguage(targetLanguage, link) {
  var restrictLanguages = featureEnabled('rubriq_restrict_languages');
  var languageRegex = restrictLanguages ? /\/(cn|en)\// : /\/(cn|jp|en|br|es)\//;
  if (link && link.match(languageRegex)) {
    var updatedLink = link.replace(languageRegex, "/".concat(targetLanguage, "/"));
    return updatedLink;
  }
  var fallbackLink = "/".concat(targetLanguage).concat(link);
  return fallbackLink;
};

/**
 * LanguageToggle toggles the language of a given site, then updates the URL to match that language
 */
var LanguageToggle = function LanguageToggle(_ref) {
  var translationContext = _ref.translationContext,
    updateSiteLanguage = _ref.updateSiteLanguage,
    language = _ref.language,
    children = _ref.children,
    path = _ref.path,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: className,
    onClick: function onClick(e) {
      if (_onClick) {
        _onClick(e);
      }
      updateSiteLanguage(language, translationContext).then(function () {
        var newLink = linkInLanguage(language, path);
        window.location.assign(newLink);
      }).catch(function () {
        var newLink = linkInLanguage(language, path);
        window.location.assign(newLink);
      });
    }
  }, children);
};
export default LanguageToggle;